<!--<div class="app-content content" *ngIf="isPageLoaded">
    <div class="content-overlay"></div>
    <div class="content-wrapper">
        <div class="content-header row">
        </div>
        <div class="content-body">
            <section class="row flexbox-container">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
                        <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
                            <div class="card-header border-0">
                                <div class="card-title text-center">
                                    <img src="assets/custom/images/abg/kg_logo.png" alt="branding logo">
                                </div>-->
<!--<h6 class="card-subtitle line-on-side text-muted text-center font-small-3 pt-2">
    <span>Easily Using</span></h6>-->
<!--</div>
<div class="card-content">

    <div class="card-body">
        <form class="form-horizontal" [formGroup]="loginForm" (ngSubmit)="tryLogin()">
            <fieldset class="form-group position-relative has-icon-left">
                <input type="text" formControlName="email" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" id="user-name"
                    placeholder="Your Username" required>
                <div class="form-control-position">
                    <i class="la la-user"></i>
                </div>
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                    <div *ngIf="f.email.errors.required">Username is required</div>
                </div>
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left">
                <input type="password" placeholder="Enter Password"
                    formControlName="password" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                <div class="form-control-position">
                    <i class="la la-key"></i>
                </div>
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                </div>

            </fieldset>
            <div class="form-group row">
                <div class="col-md-6 col-12 text-center text-sm-left pr-0">
                    <fieldset>
                        <div class="icheckbox_square-blue" id="icheckbox" (click)="addCheckbox($event)" style="position: relative;">
                            <input type="checkbox" class="chk-remember"
                                formControlName="rememberMe" name="remember-me"
                                id="remember-me" style="position: absolute; opacity: 0;">
                            <ins class="iCheck-helper"
                                style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                        </div>
                        <label class="lb-remember" for="remember-me">Remember Me</label>

                    </fieldset>
                </div>

                <div class="col-md-6 col-12 float-sm-left text-center text-sm-right"><a
                        [routerLink]="['/register']" class="card-link">Forgot Password?</a>
                </div>
            </div>
            <button type="submit" class="btn btn-outline-info btn-block">
                <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
                <i class="feather ft-unlock" *ngIf="!submitted"></i> Login
            </button>
        </form>
    </div>-->
<!--<p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1">
    <span>New to Modern ?</span></p>
<div class="card-body">
    <a [routerLink]="['/register']" class="btn btn-outline-danger btn-block"><i
            class="la la-user"></i> Register</a>
</div>-->
<!--<div class="card-body">
    <div class="row">
        <div class="col-md-6">-->
<!--<a target="_blank">Privacy Policy</a>-->
<!--<a [routerLink]="['/privacypolicy']" target="_blank">Privacy Policy</a>-->
<!--</div>
<div class="col-md-6 terms">-->
<!--<a target="_blank">Terms & Conditions</a>-->
<!--<a [routerLink]="['/termCondition']" target="_blank">Terms & Conditions</a>-->
<!--</div>
    </div>
</div>-->
<!--</div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </div>
</div>-->
<!--<div class="auth-shell" *ngIf="isPageLoaded">-->
<!-- ── LEFT: branding panel (hidden on tablet/mobile) ───────── -->
<!--<aside class="auth-brand">
  <div class="auth-brand-logo">
    <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
    <span>KG Technologys</span>
  </div>

  <h1 class="auth-brand-headline">Run your business from one secure place.</h1>
  <p class="auth-brand-sub">
    Billing, inventory, customers and reports — all in a single, fast, modern workspace built for your team.
  </p>

  <ul class="auth-brand-features">
    <li><i class="la la-bolt"></i> Lightning-fast billing &amp; invoicing</li>
    <li><i class="la la-bar-chart"></i> Real-time sales &amp; payment reports</li>
    <li><i class="la la-shield"></i> Role-based access &amp; secure sign-in</li>
    <li><i class="la la-mobile"></i> Works on desktop, tablet &amp; mobile</li>
  </ul>

  <div class="auth-brand-footer">
    © {{ '' }}KG Technologys. All rights reserved.
  </div>
</aside>-->
<!-- ── RIGHT: login form ────────────────────────────────────── -->
<!--<main class="auth-main">
  <div class="auth-card">-->
<!-- Mobile logo (shown when brand panel is hidden) -->
<!--<div class="auth-mobile-logo">
  <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
</div>

<h2 class="auth-title">Welcome back</h2>
<p class="auth-sub">Sign in to continue to your dashboard.</p>

<form class="form-horizontal" [formGroup]="loginForm" (ngSubmit)="tryLogin()">-->
<!-- Username / Email -->
<!--<div class="auth-field">
  <label class="auth-label" for="user-name">Username</label>
  <div class="auth-input-wrap">
    <input type="text"
           formControlName="email"
           class="auth-input form-control"
           [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
           id="user-name"
           placeholder="Your username"
           required />
    <i class="auth-input-icon la la-user"></i>
  </div>
  <div *ngIf="submitted && f.email.errors" class="invalid-feedback auth-error">
    <div *ngIf="f.email.errors.required">Username is required</div>
  </div>
</div>-->
<!-- Password -->
<!--<div class="auth-field">
  <label class="auth-label">Password</label>
  <div class="auth-input-wrap">
    <input [type]="showPassword ? 'text' : 'password'"
           placeholder="Enter password"
           formControlName="password"
           class="auth-input form-control auth-input--with-trail"
           [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
    <i class="auth-input-icon la la-lock"></i>
    <button type="button" class="auth-input-trail"
            (click)="showPassword = !showPassword"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
      <i class="la" [ngClass]="showPassword ? 'la-eye-slash' : 'la-eye'"></i>
    </button>
  </div>
  <div *ngIf="submitted && f.password.errors" class="invalid-feedback auth-error">
    <div *ngIf="f.password.errors.required">Password is required</div>
  </div>
</div>-->
<!-- Remember + forgot -->
<!--<div class="auth-row">
  <label class="auth-check" for="remember-me">
    <div class="icheckbox_square-blue" id="icheckbox" (click)="addCheckbox($event)" style="position: relative;">
      <input type="checkbox" class="chk-remember"
             formControlName="rememberMe" name="remember-me"
             id="remember-me" style="position: absolute; opacity: 0;" />
      <ins class="iCheck-helper"
           style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; opacity: 0;"></ins>
    </div>
    <span class="auth-check-label lb-remember">Remember me</span>
  </label>

  <a [routerLink]="['/forgotpassword']" class="auth-link card-link">Forgot password?</a>
</div>-->
<!-- Submit -->
<!--<button type="submit" class="auth-btn auth-btn-primary btn-block" [disabled]="submitted">
    <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
    <i class="feather ft-unlock" *ngIf="!submitted"></i>
    <span>{{ submitted ? 'Signing in…' : 'Login' }}</span>
  </button>
</form>-->
<!-- Create account -->
<!--<p class="auth-foot">
        New here?
        <a [routerLink]="['/register']" class="auth-link">Create an account</a>
      </p>
    </div>
  </main>
</div>-->
<!--<div class="app-content content" *ngIf="isPageLoaded">
  <div class="content-overlay"></div>
  <div class="content-wrapper">
    <div class="content-header row">
    </div>
    <div class="content-body">
      <section class="row flexbox-container">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
            <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
              <div class="card-header border-0">
                <div class="card-title text-center">
                  <img src="assets/custom/images/abg/kg logo.jpeg" alt="branding logo">
                </div>-->
<!--<h6 class="card-subtitle line-on-side text-muted text-center font-small-3 pt-2">
    <span>Easily Using</span></h6>-->
<!--</div>
<div class="card-content">

  <div class="card-body">
    <form class="form-horizontal" [formGroup]="loginForm" (ngSubmit)="tryLogin()">
      <fieldset class="form-group position-relative has-icon-left">
        <input type="text" formControlName="email" class="form-control"
               [ngClass]="{ 'is-invalid': submitted && f.email.errors }" id="user-name"
               placeholder="Your Username" required>
        <div class="form-control-position">
          <i class="la la-user"></i>
        </div>
        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
          <div *ngIf="f.email.errors.required">Username is required</div>
        </div>
      </fieldset>
      <fieldset class="form-group position-relative has-icon-left">
        <input type="password" placeholder="Enter Password"
               formControlName="password" class="form-control"
               [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
        <div class="form-control-position">
          <i class="la la-key"></i>
        </div>
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
          <div *ngIf="f.password.errors.required">Password is required</div>
        </div>

      </fieldset>
      <div class="form-group row">
        <div class="col-md-6 col-12 text-center text-sm-left pr-0">
          <fieldset>
            <div class="icheckbox_square-blue" id="icheckbox" (click)="addCheckbox($event)" style="position: relative;">
              <input type="checkbox" class="chk-remember"
                     formControlName="rememberMe" name="remember-me"
                     id="remember-me" style="position: absolute; opacity: 0;">
              <ins class="iCheck-helper"
                   style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
            </div>
            <label class="lb-remember" for="remember-me">Remember Me</label>

          </fieldset>
        </div>

        <div class="col-md-6 col-12 float-sm-left text-center text-sm-right">
          <a [routerLink]="['/register']" class="card-link">Forgot Password?</a>
        </div>
      </div>
      <button type="submit" class="btn btn-outline-info btn-block">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        <i class="feather ft-unlock" *ngIf="!submitted"></i> Login
      </button>
    </form>
  </div>-->
<!--<p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1">
    <span>New to Modern ?</span></p>
<div class="card-body">
    <a [routerLink]="['/register']" class="btn btn-outline-danger btn-block"><i
            class="la la-user"></i> Register</a>
</div>-->
<!--<div class="card-body">
    <div class="row">
        <div class="col-md-6">-->
<!--<a target="_blank">Privacy Policy</a>-->
<!--<a [routerLink]="['/privacypolicy']" target="_blank">Privacy Policy</a>-->
<!--</div>
<div class="col-md-6 terms">-->
<!--<a target="_blank">Terms & Conditions</a>-->
<!--<a [routerLink]="['/termCondition']" target="_blank">Terms & Conditions</a>-->
<!--</div>
    </div>
</div>-->
<!--</div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</div>-->



<div class="app-content content" *ngIf="isPageLoaded">
  <div class="content-overlay"></div>
  <div class="content-wrapper">
    <div class="content-header row">
    </div>
    <div class="content-body">
      <section class="row flexbox-container">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
            <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
              <div class="card-header border-0">
                <div class="card-title text-center">
                  <img src="assets/custom/images/abg/kg logo.jpeg" alt="branding logo">
                </div>
              </div>
              <div class="card-content">

                <div class="card-body">
                  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
                    {{ errorMessage }}
                  </div>
                  <form class="form-horizontal" [formGroup]="loginForm" (ngSubmit)="tryLogin()">
                    <fieldset class="form-group position-relative has-icon-left">
                      <label for="user-name" class="sr-only">Email</label>
                      <input type="email" formControlName="email" class="form-control"
                             [ngClass]="{ 'is-invalid': submitted && f.email.errors }" id="user-name"
                             placeholder="Your Email" aria-label="Email" required>
                      <div class="form-control-position">
                        <i class="la la-user"></i>
                      </div>
                      <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email is required</div>
                        <div *ngIf="!f.email.errors.required && f.email.errors.email">Enter a valid email address</div>
                      </div>
                    </fieldset>
                    <fieldset class="form-group position-relative has-icon-left">
                      <label for="login-password" class="sr-only">Password</label>
                      <input type="password" placeholder="Enter Password" id="login-password"
                             formControlName="password" class="form-control" aria-label="Password"
                             [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                      <div class="form-control-position">
                        <i class="la la-key"></i>
                      </div>
                      <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                      </div>

                    </fieldset>
                    <div class="form-group row">
                      <div class="col-md-6 col-12 text-center text-sm-left pr-0">
                        <fieldset>
                          <div class="icheckbox_square-blue" id="icheckbox" [class.checked]="f.rememberMe.value"
                               (click)="addCheckbox($event)" style="position: relative;">
                            <input type="checkbox" class="chk-remember"
                                   formControlName="rememberMe" name="remember-me"
                                   id="remember-me" aria-label="Remember Me" style="position: absolute; opacity: 0;">
                            <ins class="iCheck-helper"
                                 style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                          </div>
                          <label class="lb-remember" for="remember-me">Remember Me</label>

                        </fieldset>
                      </div>

                      <div class="col-md-6 col-12 float-sm-left text-center text-sm-right">
                        <a [routerLink]="['/forgotpassword']" class="card-link">Forgot Password?</a>
                      </div>
                    </div>
                    <!-- Task #45: only occupies space once Login.ts actually renders a widget into it
                         (environment.recaptchaSiteKey configured) — empty/invisible otherwise. -->
                    <div class="form-group" id="recaptcha-container"></div>
                    <button type="submit" class="btn btn-outline-info btn-block" [disabled]="submitted">
                      <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
                      <i class="feather ft-unlock" *ngIf="!submitted"></i> Login
                    </button>
                  </form>
                  <!-- Task #55: Google/Microsoft OAuth login. Both blocks are *ngIf-gated on
                       Login.ts's googleOAuthAvailable/microsoftOAuthAvailable, which only flip true
                       when environment.googleOAuthClientId/microsoftOAuthClientId are non-blank —
                       so this whole section renders nothing when OAuth isn't configured. -->
                  <div *ngIf="googleOAuthAvailable || microsoftOAuthAvailable">
                    <p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1">
                      <span>Or sign in with</span>
                    </p>
                    <!-- Mount point for Google Identity Services' own rendered button
                         (google.accounts.id.renderButton in Login.ts's renderGoogleButton()). -->
                    <div id="google-signin-button" *ngIf="googleOAuthAvailable"
                         class="d-flex justify-content-center mb-1"></div>
                    <button type="button" class="btn btn-outline-secondary btn-block"
                            *ngIf="microsoftOAuthAvailable" (click)="signInWithMicrosoft()">
                      <i class="la la-windows"></i> Sign in with Microsoft
                    </button>
                  </div>
                </div>
                <p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1">
                  <span>New to KG Technologys?</span>
                </p>
                <div class="card-body">
                  <a [routerLink]="['/register']" class="btn btn-outline-danger btn-block">
                    <i class="la la-user"></i> Register
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</div>



